import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  assistants: [],
  assistant_default: [],
  loading: false,
  loading2: false,
  error: null,
  createForm: {
    team_token: '',
    name: '',
    description: '',
    instructions: '',
    assistant_default: null,
    files: [],
  },
  fileOptions: [],
  createResult: {},
  deleteResult: {},
  updateForm: {
    team_token: '',
    account_token: '',
    assistant_token: '',
    name: '',
    description: '',
    instructions: '',
    assistant_default: null,
    files: [],
  },
  updateResult: {},
};

const assistantsSlice = createSlice({
  name: 'assistants',
  initialState,
  reducers: {
    fetchAssistants: (state, action) => {
      state.loading = true;
    },
    fetchAssistantsSuccess: (state, action) => {
      state.assistants = action.payload.data;
      state.loading = false;
    },
    fetchAssistantsFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearAssistantsError: (state) => {
      state.error = null;
    },
    fetchAssistantDefault: (state, action) => {
      state.loading2 = true;
    },
    fetchAssistantDefaultSuccess: (state, action) => {
      state.assistant_default = action.payload.data;
      state.loading2 = false;
    },
    fetchAssistantDefaultFailure: (state, action) => {
      state.error = action.payload;
      state.loading2 = false;
    },
    setCreateForm: (state, action) => {
      state.createForm = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    setCreateFormDefault: (state) => {
      state.createForm = {
        ...state.createForm,
        name: '',
        description: '',
        instructions: '',
        assistant_default: null,
        files: [],
      };
    },
    fetchFileOptions: (state, action) => {
      state.loading = true;
    },
    fetchFileOptionsSuccess: (state, action) => {
      state.fileOptions = action.payload.data;
      state.loading = false;
    },
    fetchFileOptionsFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    createAssistant: (state, action) => {
      state.loading = true;
    },
    createAssistantSuccess: (state, action) => {
      state.createResult = action.payload.data;
      state.loading = false;
    },
    createAssistantFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearCreateResult: (state) => {
      state.createResult = {};
    },
    setAssistants: (state, action) => {
      state.assistants = action.payload;
    },
    deleteAssistant: (state, action) => {
      state.loading = true;
    },
    deleteAssistantSuccess: (state, action) => {
      state.deleteResult = action.payload.data;
      state.loading = false;
    },
    deleteAssistantFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearDeleteResult: (state) => {
      state.deleteResult = {};
    },
    fetchUpdateForm: (state, action) => {
      state.loading = true;
    },
    fetchUpdateFormSuccess: (state, action) => {
      state.updateForm = action.payload.data;
      state.loading = false;
    },
    fetchUpdateFormFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    setUpdateForm: (state, action) => {
      state.updateForm = action.payload;
    },
    updateAssistant: (state, action) => {
      state.loading = true;
    },
    updateAssistantSuccess: (state, action) => {
      state.updateResult = action.payload.data;
      state.loading = false;
    },
    updateAssistantFailure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
    clearUpdateResult: (state) => {
      state.updateResult = {};
    },
  },
});

export const selectAssistants = (state) => state.assistants;

export const {
  fetchAssistants,
  fetchAssistantsSuccess,
  fetchAssistantsFailure,
  clearAssistantsError,
  fetchAssistantDefault,
  fetchAssistantDefaultSuccess,
  fetchAssistantDefaultFailure,
  setCreateForm,
  setError,
  setCreateFormDefault,
  fetchFileOptions,
  fetchFileOptionsSuccess,
  fetchFileOptionsFailure,
  createAssistant,
  createAssistantSuccess,
  createAssistantFailure,
  clearCreateResult,
  setAssistants,
  deleteAssistant,
  deleteAssistantSuccess,
  deleteAssistantFailure,
  clearDeleteResult,
  fetchUpdateForm,
  fetchUpdateFormSuccess,
  fetchUpdateFormFailure,
  setUpdateForm,
  updateAssistant,
  updateAssistantSuccess,
  updateAssistantFailure,
  clearUpdateResult,
} = assistantsSlice.actions;

export default assistantsSlice.reducer;